import { ReactNode, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'

interface PortalProps {
  id: 'modal' | 'dialog' | 'toast' | 'sidebar'
  children: ReactNode
}

const Portal = ({ id, children }: PortalProps) => {
  const [element, setElement] = useState<Element | null>(null)

  useEffect(() => {
    setElement(document.querySelector(`#${id}`))
  }, [id])

  if (!element) {
    return <></>
  }

  return ReactDOM.createPortal(children, element)
}

export default Portal
